// eslint-disable-next-line
export default require(`./${process.env.BRAND_NAME}/${process.env.VENDOR}/${process.env.LANG}`).default;



/** WEBPACK FOOTER **
 ** ./src/i18n/index.js
 **/